import * as React from 'react'

import { Button } from 'main/ui'
import { useTranslation } from 'react-i18next'
import { LOCIZE_NAMESPACE } from '../../../../../../../../common'
import { i18nKeyPrefix } from '../../../../../../i18n'

import { ICoreProps } from '../types'
import { InitialContainer, StyledText } from './Initial.styles'

const PRE = `${i18nKeyPrefix}-CTA-ENROLL-STEPS-INITIAL`

export default function Initial(props: ICoreProps) {
  const {
    instantEnroll,
    school: { director, name: schoolName },
    changeStep,
  } = props

  const { t } = useTranslation(LOCIZE_NAMESPACE)

  const directorName = director
    ? `${director.firstName} ${director.lastName}`
    : t(`${PRE}-THE-DIRECTOR`)

  return (
    <InitialContainer>
      <StyledText>{t(`${PRE}-TEXT`, { directorName, schoolName })}</StyledText>
      {instantEnroll && <StyledText>{t(`${PRE}-INSTANT-TEXT`)}</StyledText>}
      <Button onClick={() => changeStep()} full>
        {t(`${PRE}-NEXT`)}
      </Button>
    </InitialContainer>
  )
}
